export default "__VITE_ASSET__6NKfL1A9__"